import { render, staticRenderFns } from "./EventViewModal.vue?vue&type=template&id=89a4db86"
import script from "./EventViewModal.vue?vue&type=script&lang=js"
export * from "./EventViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports